import { Link } from "react-router-dom";
import { ORG, VENUE_ADDRESS_LINE } from "../seo/site.js";

const ctaClass =
  "btn rounded-5 px-4 py-2 fs-6 custom-btn d-inline-flex align-items-center border-bottom-left";

// Venue name, address and a directions link. Content comes from src/seo/site.js
// so it always matches the structured data and footer.
export const VenueCard = ({ className = "" }) => (
  <address className={`bg-white border rounded-4 border-bottom-left p-4 mb-0 ${className}`}>
    <p className="text-uppercase fw-bold red-text small mb-2">Where classes are held</p>
    <p className="fw-bold fs-5 mb-1">{ORG.venue.name}</p>
    <p className="mb-3">{VENUE_ADDRESS_LINE}</p>
    <a
      href={ORG.mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="green-text fw-semibold text-decoration-none"
    >
      <i className="bi bi-geo-alt-fill me-1" aria-hidden="true"></i>
      Get directions in Google Maps
      <span className="visually-hidden"> (opens in a new tab)</span>
    </a>
  </address>
);

export const ContactLines = () => (
  <ul className="list-unstyled mb-0">
    <li className="mb-2">
      <i className="bi bi-telephone-fill green-text me-2" aria-hidden="true"></i>
      Committee:{" "}
      <a href={`tel:${ORG.phones.committee.tel}`} className="fw-semibold red-text text-decoration-none">
        {ORG.phones.committee.display}
      </a>
    </li>
    <li className="mb-2">
      <i className="bi bi-telephone-fill green-text me-2" aria-hidden="true"></i>
      Principal:{" "}
      <a href={`tel:${ORG.phones.principal.tel}`} className="fw-semibold red-text text-decoration-none">
        {ORG.phones.principal.display}
      </a>
    </li>
    <li>
      <i className="bi bi-envelope-fill green-text me-2" aria-hidden="true"></i>
      Email:{" "}
      <a href={`mailto:${ORG.email}`} className="fw-semibold red-text text-decoration-none">
        {ORG.email}
      </a>
    </li>
  </ul>
);

// Closing call to action used on the class, program and enrolment pages.
export const EnquiryCta = ({
  heading = "Ready to enrol, or have a question first?",
  text = "Submit an expression of interest and our team will email you the next steps. You are also welcome to call or email us.",
}) => (
  <section className="tabs-bg py-5">
    <div className="container">
      <div className="bg-white rounded-5 border-bottom-left shadow-sm p-4 p-md-5">
        <div className="row g-4 align-items-center">
          <div className="col-lg-7">
            <h2 className="fw-bold mb-3">{heading}</h2>
            <p className="text-muted mb-4">{text}</p>
            <div className="d-flex flex-wrap gap-3">
              <Link to="/eoi/" className={`${ctaClass} red-bg text-white`}>
                Enrolment expression of interest
                <i className="bi bi-arrow-right ms-2" aria-hidden="true"></i>
              </Link>
              <Link to="/contact/" className={`${ctaClass} green-bg text-white`}>
                Contact us
              </Link>
            </div>
          </div>
          <div className="col-lg-5">
            <ContactLines />
          </div>
        </div>
      </div>
    </div>
  </section>
);
